export function getText(person) {
  let { patient } = person
  let { primary_location, human_readable_id } = patient

  return [primary_location?.name, `#${human_readable_id}`]
    .filter(Boolean)
    .join(' • ')
    .trim()
}
